export default "__VITE_ASSET__783cae33__"